import DownloadDocument from './DownloadDocument';

export default DownloadDocument;
